import { render, staticRenderFns } from "./SelectMembers.vue?vue&type=template&id=a3960dee"
import script from "./SelectMembers.vue?vue&type=script&lang=js"
export * from "./SelectMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports